import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import Routes from './routes'
import './index.css'
import store from './ducks'
import './core/fontAwesome'
import './core/extensions'
import 'react-table/react-table.css'
import 'semantic-ui-css/semantic.min.css'
import '@blueprintjs/core/lib/css/blueprint.css'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from 'variables/authConfig'
import './devTools/ReactotronConfig'

const msalInstance = new PublicClientApplication(msalConfig)

const Application = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <Routes />
      </Provider>
    </MsalProvider>
  )
}

ReactDOM.render(<Application />, document.getElementById('root'))
